export default __webpack_public_path__ + "static/media/loginbg.226712f6.jpg";